import {defineAbilityConfig} from '../system/defineAbilityConfig';

export const canAccessFormConnectionsAndNotifications = defineAbilityConfig({
  userTypes: {
    authorizedInDesigner: true,
    unauthorized: false,
  },
  siteModes: {design: true},
  workflows: {canvas: true},
} as const);
